module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.10aaef84.png";